import axios from "axios";
import React, { useEffect } from "react";
import Select from "react-select";

const CommonSupplierGet = ({
  suppliers,
  setSuppliers,
  searchInput,
  setsupplierId,
  setSearchInput,
  formik,
}) => {
  const token = sessionStorage.getItem("token");
  // const companyId =sessionStorage.getItem("companyId")
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    SupplierGet();
  }, [searchInput]);

  const Supplier_obj = { name: searchInput };
  const SupplierGet = () => {
    axios
      .post("/api/purple-fusion/supplier/get", Supplier_obj, headers)
      .then((response) => {
        setSuppliers(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sortedSupplierList = suppliers.slice().sort((a, b) => b.id - a.id);
  return (
    <>
      <Select
        name="supplier_id"
        options={sortedSupplierList.map((resstate) => ({
          label: resstate.name,
          value: resstate.id,
          state_id: resstate.state_id,
          fin_payment_term_id: resstate.fin_payment_term_id,
        }))}
        className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full text-sm"
        onChange={(selectedOption) => {
          formik.setFieldValue("supplier_id", selectedOption.value);
          formik.setFieldValue("state_id", selectedOption.state_id);
          setsupplierId(selectedOption.value);
          formik.setFieldValue(
            "fin_payment_term_id",
            selectedOption.fin_payment_term_id
          );
          console.log(selectedOption);
        }}
        onInputChange={setSearchInput}
        onBlur={formik.handleBlur}
        placeholder="Select Supplier"
      />
    </>
  );
};

export default CommonSupplierGet;
